<template>
<div class="auth-modal">
  <a href="javascript:;" class="close-auth-modal-btn" @click="$emit('dismiss')">
    <i class="fal fa-times"></i>
  </a>
  <Authentication/>
</div>
</template>

<script>
import Authentication from '@/components/auth/Authentication'

export default {
  components: {
    Authentication,
  },
}
</script>

<style lang="less">
.auth-modal {
  @apply w-full h-full relative;

  .close-auth-modal-btn {
    @apply absolute top-0 right-0 p-4 text-black;
  }
}
.auth-modal-wrapper {
  .modal-view {
    .modal-container {
      width: 650px;
    }
  }
}
</style>
